<template>
    <div class="relative" @click="$emit('click')" v-click-outside="hideDropdown">
        <template v-if="!loading">
            <button
                type="button"
                aria-haspopup="listbox"
                :aria-labelledby="`${label_id} exp_button`"
                class="h-16 px-4 placeholder-smoke-dark text-sm rounded-md  w-full bg-snow-300 flex items-center justify-between outline-none"
                id="exp_button"
                @click="showDropdown = !showDropdown"
            >
                <span class="truncate text-smoke-dark">
                    {{ option }}
                </span>
                <div class="flex items-center justify-center">
                    <div class="h-1 w-1 rounded-full bg-smoke-200 "></div>
                    <div class="h-1 w-1 rounded-full bg-smoke-200 mx-1"></div>
                    <div class="h-1 w-1 rounded-full bg-smoke-200 "></div>
                </div>
            </button>
        </template>
        <template v-else-if="loading">
            <div class="h-16 w-full skeleton rounded-lg"></div>
        </template>

        <ul
            :class="
                `rounded-lg bg-white h-48 overflow-auto py-5 absolute mt-3 z-30 dropdown right-0 outline-none ${
                    showDropdown ? '' : 'hidden'
                }`
            "
            tabindex="-1"
            role="listbox"
            :aria-labelledby="label_id"
        >
            <div class="flex items-center justify-center px-6 mb-1">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.11132 4.44447C1.11132 2.6062 2.60626 1.11126 4.44452 1.11126C6.28278 1.11126 7.77773 2.6062 7.77773 4.44447C7.77773 6.28273 6.28278 7.77767 4.44452 7.77767C2.60626 7.77767 1.11132 6.28273 1.11132 4.44447ZM9.83684 9.05131L7.9508 7.16472C8.53578 6.41253 8.88854 5.46979 8.88854 4.44427C8.88854 1.99381 6.89473 0 4.44427 0C1.99381 0 0 1.99381 0 4.44427C0 6.89473 1.99381 8.88854 4.44427 8.88854C5.46979 8.88854 6.41253 8.53578 7.16472 7.9508L9.05131 9.83684C9.15964 9.94517 9.30186 9.99961 9.44408 9.99961C9.58629 9.99961 9.72851 9.94517 9.83684 9.83684C10.0541 9.61963 10.0541 9.26853 9.83684 9.05131Z"
                        fill="#D3DCE6"
                    />
                </svg>
                <input type="text" :placeholder="`Search ${label_id}`" v-model="search" class="text-xs ml-2" />
            </div>
            <li
                role="option"
                class="flex py-3 items-center px-6 hover:bg-snow-300 duration-500 cursor-pointer text-xs text-grey-300"
                v-for="(item, i) in dropDownItems"
                @click="() => clickItem(item)"
                :key="i"
            >
                {{ item.name }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'biller-dropdown',

    data() {
        return {
            showDropdown: false,
            search: '',
            mutableItem: this.items,
        }
    },

    updated() {
        this.dropDownItems
    },

    props: {
        label_id: {
            type: String,
            required: true,
        },

        option: {
            type: String,
            required: true,
        },

        items: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        dropDownItems: function() {
            return this.mutableItem
        },
    },

    methods: {
        clickItem(item) {
            if (item.bundleCode !== '') {
                this.$emit('select', item)
                this.showDropdown = false
            }
        },
        hideDropdown() {
            this.showDropdown = false
        },
    },

    watch: {
        search: function(newValue) {
            this.mutableItem = this.items.filter((val) => val.name.toLowerCase().includes(newValue))
        },

        items: function(newValue) {
            this.$forceUpdate()
            this.mutableItem = newValue
        },
    },
}
</script>

<style scoped>
.dropdown {
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.05);
    width: 180px;
}

.skeleton {
    animation: pulse-bg 1s ease-in-out infinite normal both;
}
button {
    outline: 0;
}
</style>
